import { comluxgroup } from '@luxuryescapes/contract-data-event-schemas'
import { getOrderTravelDuration } from 'lib/order/orderUtils'
import moment from 'moment'
import getOrderDataMemberPricingMetadata from './orderMemberPricingMetadata'
import sanitizeItemContextMetadata from './sanitizeItemContextMetadata'

function getBookingProtectionOrderItems(order: App.Order, isMultiCart?: boolean) {
  return order.bookingProtectionItems.map(orderItem => {
    const { earliest, latest } = getOrderTravelDuration(order)
    const luxPlusMetaData = getOrderDataMemberPricingMetadata(orderItem)
    return comluxgroup.createItem_1_1_1(
      {
        offerId: orderItem.quoteId || 'insurance',
        categoryId: 'insurance',
        productId: 'insurance',
        itemId: orderItem.id,
        travelStart: earliest,
        travelEnd: latest,
        duration: earliest && latest ? moment(latest).diff(earliest, 'days') : undefined,
        price: orderItem.total,
        currency: order.currencyCode,
        bookingNumber: order.bookingNumber,
        orderId: order.id,
        metadata: sanitizeItemContextMetadata({
          ...luxPlusMetaData || {},
          isMultiCart,
        }),
      },
    )
  })
}

export default getBookingProtectionOrderItems
